import React from "react";
import { Testimonial } from "../_00Global/Testimonial";
import { ClarissaDavid } from "./ClarissaDavid";

interface Props {
  className?: string;
}

export const _05Testimonial: React.FC<Props> = ({ className = "" }) => {
  return (
    <div className={`flex flex-col items-center justify-center relative bg-[var(--fy-blue)] ${className}`}>
      <Testimonial
        className="!self-stretch !flex-[0_0_auto] !w-full"
        icon={<ClarissaDavid className="!h-[125px] !bg-[unset] !flex-1 !relative !bg-[unset] !bg-[unset] !grow !w-[unset]" />}
        namesAndLocation="- Clarissa & David, Essex"
        quote="&quot;Thank you so much for capturing our special day so perfectly. We couldn't be happier with our videos.&quot;"
        videoUrl="https://pcdodwcjlmnmpabyinsh.supabase.co/storage/v1/object/public/Website%20Videos/clarissa_&_david.mp4?t=2025-01-25T04%3A34%3A04.451Z"
      />
    </div>
  );
}; 